import React, { useState, useEffect } from "react";

import LayoutComponent from './LayoutComponent';

const LayoutContainer = props => {

    return (
        <LayoutComponent {...props} />
    )
}

export default LayoutContainer;